import React from 'react';
import { Section } from './ui/Section';
import { Scale } from 'lucide-react';
import { Eucalyptus } from './botanical/Eucalyptus';
export function CostTable() {
  const rows = [{
    sin: 'Farmacia de urgencia de noche',
    costo: '$8.000 a $15.000 por visita'
  }, {
    sin: 'Remedios que no necesitabas',
    costo: 'Plata tirada'
  }, {
    sin: 'Noches sin dormir sin saber qué hacer',
    costo: 'Agotamiento acumulado'
  }, {
    sin: 'Improvisar cada vez que algo duele',
    costo: 'Estrés y angustia'
  }, {
    sin: 'Buscar en Google a las 2 AM',
    costo: 'Información contradictoria'
  }];
  return <Section className="bg-cream-warm relative overflow-hidden" data-id="element-115">
      <Eucalyptus className="absolute top-20 -right-20 w-80 h-80 text-moss opacity-10 blur-sm -rotate-12" data-id="element-116" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-117">
        <div className="text-center mb-10" data-id="element-118">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-moss/10 mb-4 border border-moss/20" data-id="element-119">
            <Scale className="w-6 h-6 text-moss" data-id="element-120" />
          </div>
          <h2 className="text-3xl font-serif font-bold text-forest-deep" data-id="element-121">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="md:hidden text-xs text-sage-deep text-center mb-2 flex items-center justify-center gap-2" data-id="element-122">
          <span data-id="element-123">← Scroll to see full table →</span>
        </div>

        <div className="overflow-x-auto pb-4 hide-scrollbar mb-10" data-id="element-124">
          <div className="min-w-[500px] bg-white/90 backdrop-blur-sm rounded-2xl shadow-sm border border-sage-mist overflow-hidden" data-id="element-125">
            <table className="w-full text-left border-collapse" data-id="element-126">
              <thead data-id="element-127">
                <tr className="bg-terracotta/5 border-b border-terracotta/10" data-id="element-128">
                  <th className="py-4 px-6 font-serif font-bold text-terracotta w-1/2" data-id="element-129">
                    SIN HOGAR NATURAL
                  </th>
                  <th className="py-4 px-6 font-serif font-bold text-forest-deep w-1/2" data-id="element-130">
                    COSTO REAL
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-131">
                {rows.map((row, idx) => <tr key={idx} className="border-b border-sage-mist/50 last:border-0" data-id="element-132">
                    <td className="py-4 px-6 text-forest/70" data-id="element-133">{row.sin}</td>
                    <td className="py-4 px-6 font-medium text-forest-deep" data-id="element-134">
                      {row.costo}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <p className="text-2xl font-serif font-bold text-forest-deep text-center italic" data-id="element-135">
          La próxima noche puede ser completamente distinta. 🌿🇦🇷
        </p>
      </div>
    </Section>;
}